import { atom } from 'jotai';
import { allTeamsAtom } from '@/atoms/queries/allTeams';
import { userDefaultTeamIdsAtom } from '@/atoms/queries/teams';

// The user's licensed default team, or undefined when it is unset or unlicensed. The team record comes
// from the same teams list userDefaultTeamIdsAtom validates against, so it resolves in one step.
export const homeDefaultTeamAtom = atom(async get => {
  const [defaultTeamIds, allTeams] = await Promise.all([get(userDefaultTeamIdsAtom), get(allTeamsAtom)]);
  if (!defaultTeamIds) return undefined;

  return allTeams.find(team => team.team_id === defaultTeamIds.datahubId);
});
